import { post, get } from './index'
/**
 * 热点聚焦
 */
export default {
  // 条件查询
  getIndustryNewsByCondition: (params) => post('IndustryNews/getIndustryNewsByCondition', params),
  // 查看详情
  getDetails: (id) => get('IndustryNews/getDetails/' + id),
}

